import { useEffect } from 'react';

export const useCustomCursor = () => {
  useEffect(() => {
    const buttons = document.querySelectorAll('.schedule-btn');
    
    const handleMouseMove = (e, button) => {
      const cursor = button.querySelector('.custom-cursor');
      if (!cursor) return;
      
      const rect = button.getBoundingClientRect();
      const x = e.clientX - rect.left - 20;
      const y = e.clientY - rect.top - 20;
      cursor.style.transform = `translate(${x}px, ${y}px)`;
    };

    const handleMouseEnter = (button) => {
      const cursor = button.querySelector('.custom-cursor');
      if (!cursor) return;
      cursor.style.opacity = '1';
    };

    const handleMouseLeave = (button) => {
      const cursor = button.querySelector('.custom-cursor');
      if (!cursor) return;
      cursor.style.opacity = '0';
    };

    buttons.forEach(button => {
      button.addEventListener('mousemove', (e) => handleMouseMove(e, button));
      button.addEventListener('mouseenter', () => handleMouseEnter(button));
      button.addEventListener('mouseleave', () => handleMouseLeave(button));
    });

    return () => {
      buttons.forEach(button => {
        button.removeEventListener('mousemove', (e) => handleMouseMove(e, button));
        button.removeEventListener('mouseenter', () => handleMouseEnter(button));
        button.removeEventListener('mouseleave', () => handleMouseLeave(button));
      });
    };
  }, []);
};